class Point {
    x: number;
    y: number;
    z: number;
    constructor(x: number, y: number, z: number) {
        this.x = x;
        this.y = y;
        this.z = z;
    }

    getX(): number {
        return this.x;
    }

    getY(): number {
        return this.y;
    }

    getZ(): number {
        return this.z;
    }

    adjust(dx: number, dy: number, dz: number): Point {
        return new Point(this.x + dx, this.y + dy, this.z + dz);
    }

    clone(): Point {
        return new Point(this.x, this.y, this.z);
    }

    addScalar(n: number): Point {
        return this.adjust(n, n, n);
    }

    subScalar(n: number): Point {
        const negN = n * -1;
        return this.adjust(negN, negN, negN);
    }

    multScalar(n: number): Point {
        return new Point(this.x * n, this.y * n, this.z * n);
    }

    divScalar(n: number): Point {
        return new Point(this.x / n, this.y / n, this.z / n);
    }

    neg(): Point {
        return this.multScalar(-1);
    }

    addPoint(point: Point): Point {
        return this.adjust(point.x, point.y, point.z);
    }
}

export default Point;
